/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type RecordPlatformMCPAgentConfigurationCopiedSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type RecordPlatformMCPAgentConfigurationCopiedRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type RecordPlatformMCPAgentConfigurationCopiedSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const RecordPlatformMCPAgentConfigurationCopiedSecurity$outboundSchema:
  z.ZodMiniType<
    RecordPlatformMCPAgentConfigurationCopiedSecurity$Outbound,
    RecordPlatformMCPAgentConfigurationCopiedSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function recordPlatformMCPAgentConfigurationCopiedSecurityToJSON(
  recordPlatformMCPAgentConfigurationCopiedSecurity:
    RecordPlatformMCPAgentConfigurationCopiedSecurity,
): string {
  return JSON.stringify(
    RecordPlatformMCPAgentConfigurationCopiedSecurity$outboundSchema.parse(
      recordPlatformMCPAgentConfigurationCopiedSecurity,
    ),
  );
}

/** @internal */
export type RecordPlatformMCPAgentConfigurationCopiedRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const RecordPlatformMCPAgentConfigurationCopiedRequest$outboundSchema:
  z.ZodMiniType<
    RecordPlatformMCPAgentConfigurationCopiedRequest$Outbound,
    RecordPlatformMCPAgentConfigurationCopiedRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
      });
    }),
  );

export function recordPlatformMCPAgentConfigurationCopiedRequestToJSON(
  recordPlatformMCPAgentConfigurationCopiedRequest:
    RecordPlatformMCPAgentConfigurationCopiedRequest,
): string {
  return JSON.stringify(
    RecordPlatformMCPAgentConfigurationCopiedRequest$outboundSchema.parse(
      recordPlatformMCPAgentConfigurationCopiedRequest,
    ),
  );
}
